import InvestorInvestmentDetailContent from './investor-investment-detail-content';

export default InvestorInvestmentDetailContent;
